export default __webpack_public_path__ + "static/media/Web-Hosting-Header.ac3c0f9a.png";